(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-individual-photo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-product-gallery')) {
  customElements.define('hs-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.main = this.querySelector('[data-hs-gallery-main]');
      this.stage = this.querySelector('.hs-individual-stage');
      this.video = this.querySelector('[data-hs-gallery-video]');
      this.toggle = this.querySelector('[data-hs-gallery-toggle]');
      this.status = this.querySelector('[data-hs-gallery-status]');
      this.buttons = Array.from(this.querySelectorAll('[data-hs-gallery-url]'));
      if (!this.main || this.buttons.length < 2) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.index = 0;
      this.manualPaused = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const bounds = this.stage.getBoundingClientRect();
      this.inView = bounds.bottom > 0 && bounds.top < innerHeight;
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.selectImage(index), {signal});
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          if (event.key === 'ArrowLeft') next = (index + this.buttons.length - 1) % this.buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.selectImage(next);
          this.buttons[next].focus({preventScroll:true});
          this.revealThumbnail(this.buttons[next]);
        }, {signal});
      });
      let start;
      this.stage.addEventListener('touchstart', event => {
        start = event.touches.length === 1 && !event.target.closest('button') ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
      }, {passive:true,signal});
      this.stage.addEventListener('touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const touch = event.changedTouches[0], dx = touch.clientX - start.x, dy = touch.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        this.selectImage((this.index + (dx < 0 ? 1 : this.buttons.length - 1)) % this.buttons.length);
        this.revealThumbnail(this.buttons[this.index]);
      }, {passive:true,signal});
      this.stage.addEventListener('touchcancel', () => {start = null;}, {passive:true,signal});
      if (this.video) {
        this.video.muted = true;
        this.video.addEventListener('play', () => this.updateToggle(), {signal});
        this.video.addEventListener('pause', () => this.updateToggle(), {signal});
        this.toggle.addEventListener('click', () => {
          this.manualPaused = !this.video.paused;
          this.motionRequested = !this.manualPaused;
          this.syncPlayback();
        }, {signal});
        this.reducedMotion.addEventListener('change', () => {
          this.motionRequested = false;
          this.manualPaused = this.reducedMotion.matches;
          this.syncPlayback();
        }, {signal});
        document.addEventListener('visibilitychange', () => this.syncPlayback(), {signal});
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, {threshold:0.1});
        this.observer.observe(this.stage);
      }
    }
    revealThumbnail(button) {
      const strip = button.parentElement;
      const left = button.offsetLeft - strip.offsetLeft;
      if (left < strip.scrollLeft) strip.scrollLeft = left;
      else if (left + button.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + button.offsetWidth - strip.clientWidth;
    }
    selectImage(index) {
      const button = this.buttons[index];
      if (!button) return;
      this.index = index;
      const isVideo = button.dataset.hsGalleryType === 'video';
      if (this.video) this.video.pause();
      this.main.hidden = isVideo;
      if (this.video) {
        this.video.hidden = !isVideo;
        this.toggle.hidden = !isVideo;
      }
      if (isVideo && this.video) {
        const poster = new URL(button.dataset.hsGalleryPoster, location.href);
        poster.searchParams.set('width', 900);
        this.video.poster = poster.href;
        this.video.setAttribute('aria-label', button.dataset.hsGalleryAlt);
        if (this.video.getAttribute('src') !== button.dataset.hsGalleryUrl) {
          this.video.src = button.dataset.hsGalleryUrl;
          this.video.load();
        } else this.video.currentTime = 0;
        this.manualPaused = this.reducedMotion.matches;
        this.motionRequested = false;
        this.syncPlayback();
      } else {
        if (this.video?.hasAttribute('src')) {this.video.removeAttribute('src');this.video.load();}
        const url = button.dataset.hsGalleryUrl;
        const join = url.includes('?') ? '&' : '?';
        this.main.srcset = [350,500,700,900,1254].map(width => url + join + 'width=' + width + ' ' + width + 'w').join(', ');
        this.main.src = url + join + 'width=900';
        this.main.alt = button.dataset.hsGalleryAlt;
      }
      this.buttons.forEach((item, i) => item.setAttribute('aria-pressed', String(i === index)));
      if (this.status) this.status.textContent = button.getAttribute('aria-label');
    }
    shouldPlay() {
      return this.video && !this.video.hidden && this.inView && !document.hidden && !this.manualPaused && (!this.reducedMotion.matches || this.motionRequested);
    }
    syncPlayback() {
      if (!this.video) return;
      if (this.shouldPlay()) {
        this.video.play().then(() => {
          if (!this.shouldPlay()) this.video.pause();
          this.updateToggle();
        }).catch(() => this.updateToggle());
      } else this.video.pause();
      this.updateToggle();
    }
    updateToggle() {
      if (!this.toggle) return;
      const playing = !this.video.paused;
      this.toggle.textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.toggle.setAttribute('aria-label', playing ? this.dataset.pauseAria : this.dataset.playAria);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.video?.pause();
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-ingredients"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-ingredients-motion')) {
  customElements.define('hs-ingredients-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userChoice = null;
      this.inView = false;
      this.video.muted = true;
      this.button.hidden = false;
      this.updateButton = () => {
        const paused = this.video.paused;
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.querySelector('[data-motion-icon]').setAttribute('d', paused ? 'M4 2L14 8L4 14Z' : 'M3 2H6V14H3ZM10 2H13V14H10Z');
      };
      this.sync = () => {
        const wantsPlay = this.userChoice === null ? !this.motion.matches : this.userChoice;
        if (!this.inView || document.hidden || !wantsPlay) {
          this.video.pause();
          return;
        }
        if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
        this.video.play().catch(() => this.updateButton());
      };
      this.button.addEventListener('click', () => {
        this.userChoice = this.video.paused;
        this.sync();
      }, options);
      this.video.addEventListener('play', this.updateButton, options);
      this.video.addEventListener('pause', this.updateButton, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.motion.addEventListener('change', this.sync, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      } else {
        this.inView = true;
        this.sync();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
      this.events = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
